// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/change_vision_member_role.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionMemberRole } from "./vision_membership_pb";
import { file_vision_membership_v1_vision_membership } from "./vision_membership_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/change_vision_member_role.proto.
 */
export const file_vision_membership_v1_change_vision_member_role: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vbWVtYmVyc2hpcC92MS9jaGFuZ2VfdmlzaW9uX21lbWJlcl9yb2xlLnByb3RvEhtwcm90b3MudmlzaW9uLm1lbWJlcnNoaXAudjEi4QEKHUNoYW5nZVZpc2lvbk1lbWJlclJvbGVSZXF1ZXN0ElEKBnBhcmFtcxgBIAEoCzJBLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5DaGFuZ2VWaXNpb25NZW1iZXJSb2xlUmVxdWVzdC5QYXJhbXMabQoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEgoKYWNjb3VudF9pZBgCIAEoCRI7CgRyb2xlGAMgASgOMi0ucHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxLlZpc2lvbk1lbWJlclJvbGUifgoeQ2hhbmdlVmlzaW9uTWVtYmVyUm9sZVJlc3BvbnNlElIKBnJlc3VsdBgBIAEoCzJCLnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5DaGFuZ2VWaXNpb25NZW1iZXJSb2xlUmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z", [file_vision_membership_v1_vision_membership]);

/**
 * @generated from message protos.vision.membership.v1.ChangeVisionMemberRoleRequest
 */
export type ChangeVisionMemberRoleRequest = Message<"protos.vision.membership.v1.ChangeVisionMemberRoleRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ChangeVisionMemberRoleRequest.Params params = 1;
   */
  params?: ChangeVisionMemberRoleRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ChangeVisionMemberRoleRequest.
 * Use `create(ChangeVisionMemberRoleRequestSchema)` to create a new message.
 */
export const ChangeVisionMemberRoleRequestSchema: GenMessage<ChangeVisionMemberRoleRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_change_vision_member_role, 0);

/**
 * @generated from message protos.vision.membership.v1.ChangeVisionMemberRoleRequest.Params
 */
export type ChangeVisionMemberRoleRequest_Params = Message<"protos.vision.membership.v1.ChangeVisionMemberRoleRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string account_id = 2;
   */
  accountId: string;

  /**
   * @generated from field: protos.vision.membership.v1.VisionMemberRole role = 3;
   */
  role: VisionMemberRole;
};

/**
 * Describes the message protos.vision.membership.v1.ChangeVisionMemberRoleRequest.Params.
 * Use `create(ChangeVisionMemberRoleRequest_ParamsSchema)` to create a new message.
 */
export const ChangeVisionMemberRoleRequest_ParamsSchema: GenMessage<ChangeVisionMemberRoleRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_change_vision_member_role, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.ChangeVisionMemberRoleResponse
 */
export type ChangeVisionMemberRoleResponse = Message<"protos.vision.membership.v1.ChangeVisionMemberRoleResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ChangeVisionMemberRoleResponse.Result result = 1;
   */
  result?: ChangeVisionMemberRoleResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ChangeVisionMemberRoleResponse.
 * Use `create(ChangeVisionMemberRoleResponseSchema)` to create a new message.
 */
export const ChangeVisionMemberRoleResponseSchema: GenMessage<ChangeVisionMemberRoleResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_change_vision_member_role, 1);

/**
 * @generated from message protos.vision.membership.v1.ChangeVisionMemberRoleResponse.Result
 */
export type ChangeVisionMemberRoleResponse_Result = Message<"protos.vision.membership.v1.ChangeVisionMemberRoleResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.ChangeVisionMemberRoleResponse.Result.
 * Use `create(ChangeVisionMemberRoleResponse_ResultSchema)` to create a new message.
 */
export const ChangeVisionMemberRoleResponse_ResultSchema: GenMessage<ChangeVisionMemberRoleResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_change_vision_member_role, 1, 0);

